// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { autorun } from "mobx";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Enums

import "#/modules/index.ts";
import { parsePlaceholderText } from "#/common/Utils";
import { HeadlineNews } from "../../../components/headline_news/HeadlineNews";
import { Api } from "../../../api";

@Observer
@Component({
  mixins: [template],
  components: {
    HeadlineNews,
  },
})
export class DefaultLayout extends Vue {
  private showHeader: boolean = false;
  private showMobileMenu: boolean = false;
  private cookieMoreInfo: boolean = false;

  public mounted() {
    this.$eventBus.$on(
      "cms.header.show.with-mobile-menu",
      this.showHeaderAndMobileMenuManually
    );
  }

  public beforeDestroy() {
    this.$eventBus.$off(
      "cms.header.show.with-mobile-menu",
      this.showHeaderAndMobileMenuManually
    );
  }

  public handleBodyPaddingChanged(padding: number) {
    this.$store.ui.bodyPadding = padding;
  }

  public handleFlyoutUpdate(flyout: string) {
    this.$store.ui.activeFlyout = flyout;
  }

  public async handleIsUserLoggedIn(loggedIn: boolean) {
    this.$store.ui.isLoggedIn = loggedIn;
  }

  public handleActiveOverlay(overlay) {
    if (overlay) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  public handleFooterClick(itemName: string) {
    // @ts-ignore
    this.$refs["Header"].openPolicy(itemName);
  }

  public handleCookieAccept(accepted: boolean) {
    if (accepted) {
      // @ts-ignore
      window._paq.push(["rememberConsentGiven"]);
    }

    Api.authService.updateTrackingStatus(accepted);
    // @ts-ignore
    this.$refs["CookieLayer"].handleAgree();
  }

  public toggleMoreInfo() {
    this.cookieMoreInfo = !this.cookieMoreInfo;
  }

  public parseCookieLinkText(text: string, start: string, end: string) {
    return parsePlaceholderText(text, start, end);
  }

  get dashboardInstance() {
    return {
      tile_size: "large",
      sparten_filter: false,
      kacheln: [],
    };
  }

  private showHeaderAndMobileMenuManually() {
    this.showHeader = true;
    this.showMobileMenu = true;

    setTimeout(() => {
      this.showHeader = false;
      this.showMobileMenu = false;
    }, 500);
  }
}
